import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 33 32",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: ".5",
  width: "32",
  height: "32",
  rx: "16",
  "fill-opacity": ".2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.5 19.419a3.335 3.335 0 0 1-2.3-1.03A3.602 3.602 0 0 1 13.204 16a3.5 3.5 0 0 1 .965-2.424A3.234 3.234 0 0 1 16.5 12.57c.875 0 1.713.362 2.331 1.005A3.5 3.5 0 0 1 19.797 16a3.628 3.628 0 0 1-1.003 2.383 3.361 3.361 0 0 1-2.294 1.036Zm6.593-5.136h-.499a6.655 6.655 0 0 0-.617-1.559l.353-.367c.205-.214.32-.505.32-.808 0-.303-.115-.593-.32-.808l-.777-.808a1.08 1.08 0 0 0-.777-.334c-.291 0-.57.12-.777.334l-.353.367a6.176 6.176 0 0 0-1.499-.642v-.515a1.17 1.17 0 0 0-.322-.807A1.082 1.082 0 0 0 17.049 8h-1.098c-.292.001-.57.122-.776.336a1.17 1.17 0 0 0-.323.807v.519a6.175 6.175 0 0 0-1.5.642L13 9.937a1.08 1.08 0 0 0-.777-.334c-.291 0-.57.12-.777.334l-.773.814a1.17 1.17 0 0 0-.321.808c0 .303.115.594.32.808l.353.367a6.661 6.661 0 0 0-.617 1.56h-.502c-.29 0-.567.12-.773.332a1.17 1.17 0 0 0-.325.803v1.142c0 .303.117.593.322.807.206.214.485.335.776.336h.5c.14.545.347 1.07.617 1.56l-.353.366a1.17 1.17 0 0 0-.32.808c0 .303.115.593.32.808l.777.808c.206.214.486.334.777.334.291 0 .57-.12.777-.334l.353-.367c.47.28.974.496 1.499.642v.518c0 .303.117.593.322.807.206.214.485.335.775.336h1.1c.29-.001.57-.122.775-.336a1.17 1.17 0 0 0 .323-.807v-.519a6.155 6.155 0 0 0 1.5-.642l.352.367c.206.214.486.334.777.334.291 0 .57-.12.777-.334l.777-.808a1.17 1.17 0 0 0 .32-.808 1.17 1.17 0 0 0-.32-.808l-.353-.367c.27-.49.477-1.013.617-1.559h.498c.292 0 .57-.122.776-.336a1.17 1.17 0 0 0 .323-.807V15.43a1.17 1.17 0 0 0-.323-.807 1.082 1.082 0 0 0-.776-.336v-.003Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };